
/*!
 * Vue.js v2.5.16
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
$(function() {
	let jsonPath;
	let pagePath = location.pathname;
	let areas;

	if(pagePath === '/jp/dealers/' || pagePath === '/jp/dealers/index.html' ) {
		jsonPath = '/jp/dealers/dealers.json';
		areas = [
			{ text: "すべての地域", value: "" },
			{ text: "北海道", value: "1" },
			{ text: "青森県", value: "2" },
			{ text: "岩手県", value: "3" },
			{ text: "宮城県", value: "4" },
			{ text: "秋田県", value: "5" },
			{ text: "山形県", value: "6" },
			{ text: "福島県", value: "7" },
			{ text: "茨城県", value: "8" },
			{ text: "栃木県", value: "9" },
			{ text: "群馬県", value: "10" },
			{ text: "埼玉県", value: "11" },
			{ text: "千葉県", value: "12" },
			{ text: "東京都", value: "13" },
			{ text: "神奈川県", value: "14" },
			{ text: "新潟県", value: "15" },
			{ text: "富山県", value: "16" },
			{ text: "石川県", value: "17" },
			{ text: "福井県", value: "18" },
			{ text: "山梨県", value: "19" },
			{ text: "長野県", value: "20" },
			{ text: "岐阜県", value: "21" },
			{ text: "静岡県", value: "22" },
			{ text: "愛知県", value: "23" },
			{ text: "三重県", value: "24" },
			{ text: "滋賀県", value: "25" },
			{ text: "京都府", value: "26" },
			{ text: "大阪府", value: "27" },
			{ text: "兵庫県", value: "28" },
			{ text: "奈良県", value: "29" },
			{ text: "和歌山県", value: "30" },
			{ text: "鳥取県", value: "31" },
			{ text: "島根県", value: "32" },
			{ text: "岡山県", value: "33" },
			{ text: "広島県", value: "34" },
			{ text: "山口県", value: "35" },
			{ text: "徳島県", value: "36" },
			{ text: "香川県", value: "37" },
			{ text: "愛媛県", value: "38" },
			{ text: "高知県", value: "39" },
			{ text: "福岡県", value: "40" },
			{ text: "佐賀県", value: "41" },
			{ text: "長崎県", value: "42" },
			{ text: "熊本県", value: "43" },
			{ text: "大分県", value: "44" },
			{ text: "宮崎県", value: "45" },
			{ text: "鹿児島県", value: "46" },
			{ text: "沖縄県", value: "47" }
		];
	}else if(pagePath === '/cn/dealers/' || pagePath === '/cn/dealers/index.html' ) {
		jsonPath = '/cn/dealers/dealers.json';
		areas = [
			{ text: "ALL", value: "" },
			{ text: "安徽省", value: "1" },
			{ text: "福建省", value: "2" },
			{ text: "甘肃省", value: "3" },
			{ text: "广东省", value: "4" },
			{ text: "贵州省", value: "5" },
			{ text: "海南省", value: "6" },
			{ text: "河北省", value: "7" },
			{ text: "黑龙江省", value: "8" },
			{ text: "河南省", value: "9" },
			{ text: "湖北省", value: "10" },
			{ text: "湖南省", value: "11" },
			{ text: "江苏省", value: "12" },
			{ text: "江西省", value: "13" },
			{ text: "吉林省", value: "14" },
			{ text: "陕西省", value: "15" },
			{ text: "山东省", value: "16" },
			{ text: "山西省", value: "17" },
			{ text: "四川省", value: "18" },
			{ text: "云南省", value: "19" },
			{ text: "浙江省", value: "20" },
			{ text: "广西壮族自治区", value: "21" },
			{ text: "内蒙古自治区", value: "22" },
			{ text: "新疆维吾尔自治区", value: "23" },
			{ text: "西藏自治区", value: "24" },
			{ text: "北京市", value: "25" },
			{ text: "重庆市", value: "26" },
			{ text: "上海市", value: "27" },
			{ text: "天津市", value: "28" }
		];
	}else if(pagePath === '/usa/dealers/' || pagePath === '/usa/dealers/index.html' ) {
		jsonPath = '/usa/dealers/dealers.json';
		areas = [
			{ text: "ALL", value: "" },
			{ text: "Alabama", value: "1" },
			{ text: "Alaska", value: "2" },
			{ text: "Arizona", value: "3" },
			{ text: "Arkansas", value: "4" },
			{ text: "California", value: "5" },
			{ text: "Colorado", value: "6" },
			{ text: "Connecticut", value: "7" },
			{ text: "Delaware", value: "8" },
			{ text: "Florida", value: "9" },
			{ text: "Georgia", value: "10" },
			{ text: "Guam", value: "11" },
			{ text: "Hawaii", value: "12" },
			{ text: "Idaho", value: "13" },
			{ text: "Illinois", value: "14" },
			{ text: "Indiana", value: "15" },
			{ text: "Iowa", value: "16" },
			{ text: "Kansas", value: "17" },
			{ text: "Kentucky", value: "18" },
			{ text: "Louisiana", value: "19" },
			{ text: "Maine", value: "20" },
			{ text: "Maryland", value: "21" },
			{ text: "Massachusetts", value: "22" },
			{ text: "Michigan", value: "23" },
			{ text: "Minnesota", value: "24" },
			{ text: "Mississippi", value: "25" },
			{ text: "Missouri", value: "26" },
			{ text: "Montana", value: "27" },
			{ text: "Nebraska", value: "28" },
			{ text: "Nevada", value: "29" },
			{ text: "New Hampshire", value: "30" },
			{ text: "New Jersey", value: "31" },
			{ text: "New Mexico", value: "32" },
			{ text: "New York", value: "33" },
			{ text: "North Carolina", value: "34" },
			{ text: "North Dakota", value: "35" },
			{ text: "Ohio", value: "36" },
			{ text: "Oklahoma", value: "37" },
			{ text: "Oregon", value: "38" },
			{ text: "Pennsylvania", value: "39" },
			{ text: "Puerto Rico", value: "40" },
			{ text: "Rhode Island", value: "41" },
			{ text: "South Carolina", value: "42" },
			{ text: "South Dakota", value: "43" },
			{ text: "Tennessee", value: "44" },
			{ text: "Texas", value: "45" },
			{ text: "Utah", value: "46" },
			{ text: "Vermont", value: "47" },
			{ text: "Virginia", value: "48" },
			{ text: "Washington", value: "49" },
			{ text: "West Virginia", value: "50" },
			{ text: "Wisconsin", value: "51" },
			{ text: "Wyoming", value: "52" }
		];
	}else if(pagePath === '/eu/prestigedealers/' || pagePath === '/eu/prestigedealers/index.html') {
		jsonPath = '/eu/prestigedealers/dealers.json';
		areas = [
			{ text: "ALL", value: "" },
			{ text: "Andorra", value: "1" },
			{ text: "Austria", value: "2" },
			{ text: "Belgium", value: "3" },
			{ text: "Croatia", value: "4" },
			{ text: "Denmark", value: "5" },
			{ text: "Estonia", value: "6" },
			{ text: "Finland", value: "7" },
			{ text: "France", value: "8" },
			{ text: "Germany", value: "9" },
			{ text: "Greece", value: "10" },
			{ text: "Hungary", value: "11" },
			{ text: "Ireland", value: "12" },
			{ text: "Italy", value: "13" },
			{ text: "Latvia", value: "14" },
			{ text: "Lithuania", value: "15" },
			{ text: "Luxembourg", value: "16" },
			{ text: "Netherlands", value: "17" },
			{ text: "Norway", value: "18" },
			{ text: "Poland", value: "19" },
			{ text: "Portugal", value: "20" },
			{ text: "Romania", value: "21" },
			{ text: "Russia", value: "22" },
			{ text: "Serbia", value: "23" },
			{ text: "Slovenia", value: "24" },
			{ text: "Spain", value: "25" },
			{ text: "Sweden", value: "26" },
			{ text: "United Kingdom", value: "27" },
			{ text: "Ukraine", value: "28" }
		];

	}else if(pagePath === '/eu/support/contact/' || pagePath === '/eu/support/contact/index.html' ) {
		jsonPath = '/eu/support/contact/contact.json';
		areas = [
			{ text: "ALL", value: "" },
			{ text: "Andorra", value: "1" },
			{ text: "Armenia", value: "2" },
			{ text: "Austria", value: "3" },
			{ text: "Azerbaijan", value: "4" },
			{ text: "Belarus", value: "5" },
			{ text: "Belgium", value: "6" },
			{ text: "Bosnia and Herzegovina", value: "7" },
			{ text: "Bulgaria", value: "8" },
			{ text: "Croatia", value: "9" },
			{ text: "Cyprus", value: "10" },
			{ text: "Czech", value: "11" },
			{ text: "Denmark", value: "12" },
			{ text: "Estonia", value: "13" },
			{ text: "Finland", value: "14" },
			{ text: "France", value: "15" },
			{ text: "Georgia", value: "16" },
			{ text: "Germany", value: "17" },
			{ text: "Greece", value: "18" },
			{ text: "Hungary", value: "19" },
			{ text: "Iceland", value: "20" },
			{ text: "Ireland", value: "21" },
			{ text: "Italy", value: "22" },
			{ text: "Ivory Coast (Cote d'Ivoire)", value: "23" },
			{ text: "Kazakhstan", value: "24" },
			{ text: "Kirgizstan", value: "25" },
			{ text: "Latvia", value: "26" },
			{ text: "Lithuania", value: "27" },
			{ text: "Luxemburg", value: "28" },
			{ text: "Macedonia", value: "29" },
			{ text: "Malta", value: "30" },
			{ text: "Moldova", value: "31" },
			{ text: "Montenegro", value: "32" },
			{ text: "Netherlands", value: "33" },
			{ text: "Norway", value: "34" },
			{ text: "Poland", value: "35" },
			{ text: "Portugal", value: "36" },
			{ text: "Reunion", value: "37" },
			{ text: "Romania", value: "38" },
			{ text: "Russia", value: "39" },
			{ text: "Serbia", value: "40" },
			{ text: "Slovakia", value: "41" },
			{ text: "Slovenia", value: "42" },
			{ text: "Spain", value: "43" },
			{ text: "Sweden", value: "44" },
			{ text: "Switzerland", value: "45" },
			{ text: "Tajikistan", value: "46" },
			{ text: "Turkey", value: "47" },
			{ text: "Turkmenistan", value: "48" },
			{ text: "U.K.", value: "49" },
			{ text: "Ukraine", value: "50" },
			{ text: "Uzbekistan", value: "51" }
		];
	}else if(pagePath === '/asia/support/contact/' || pagePath === '/asia/support/contact/index.html' ) {
		jsonPath = '/asia/support/contact/contact.json';
		areas = [
			{ text: "ALL", value: "" },
			{ text: "Afghanistan", value: "1" },
			{ text: "Algeria", value: "2" },
			{ text: "Angola", value: "3" },
			{ text: "Bahrain", value: "4" },
			{ text: "Bangladesh", value: "5" },
			{ text: "Benin", value: "6" },
			{ text: "Brunei", value: "7" },
			{ text: "Burkina Fasso", value: "8" },
			{ text: "Cameroon", value: "9" },
			{ text: "Central African Republic", value: "10" },
			{ text: "Chad", value: "11" },
			{ text: "Congo", value: "12" },
			{ text: "Congo, the Democratic Republic of the", value: "13" },
			{ text: "Egypt", value: "14" },
			{ text: "Eritrea", value: "15" },
			{ text: "Ethiopia", value: "16" },
			{ text: "Gabon", value: "17" },
			{ text: "Ghanna", value: "18" },
			{ text: "Guinea", value: "19" },
			{ text: "Hong Kong", value: "20" },
			{ text: "India", value: "21" },
			{ text: "Indonesia", value: "22" },
			{ text: "Iran", value: "23" },
			{ text: "Iraq", value: "24" },
			{ text: "Israel", value: "25" },
			{ text: "Jordan", value: "26" },
			{ text: "Kenya", value: "27" },
			{ text: "Korea", value: "28" },
			{ text: "Kuwait", value: "29" },
			{ text: "Laos", value: "30" },
			{ text: "Lebanon", value: "31" },
			{ text: "Lesotho", value: "32" },
			{ text: "Liberia", value: "33" },
			{ text: "Madagascar", value: "34" },
			{ text: "Malawi", value: "35" },
			{ text: "Malaysia", value: "36" },
			{ text: "Mali", value: "37" },
			{ text: "Mauritius", value: "38" },
			{ text: "Morocco", value: "39" },
			{ text: "Mozambique", value: "40" },
			{ text: "Myanmar", value: "41" },
			{ text: "Namibia", value: "42" },
			{ text: "Niger", value: "43" },
			{ text: "Nigeria", value: "44" },
			{ text: "Oman", value: "45" },
			{ text: "Pakistan", value: "46" },
			{ text: "Philippines", value: "47" },
			{ text: "Qatar", value: "48" },
			{ text: "Ruwanda", value: "49" },
			{ text: "Saudi Arabia", value: "50" },
			{ text: "Senegal", value: "51" },
			{ text: "Singapore", value: "52" },
			{ text: "South Africa", value: "53" },
			{ text: "Sri-Lanka", value: "54" },
			{ text: "Sudan", value: "55" },
			{ text: "Swaziland", value: "56" },
			{ text: "Syria", value: "57" },
			{ text: "Taiwan R.O.C", value: "58" },
			{ text: "Tanzania", value: "59" },
			{ text: "Thailand", value: "60" },
			{ text: "Togo", value: "61" },
			{ text: "Tunisia", value: "62" },
			{ text: "Uganda", value: "63" },
			{ text: "United Arab Emirates", value: "64" },
			{ text: "Vietnam", value: "65" },
			{ text: "Yemen", value: "66" },
			{ text: "Zambia", value: "67" },
			{ text: "Zimbabwe", value: "68" }
		];
	}else if(pagePath === '/na/support/contact/' || pagePath === '/na/support/contact/index.html' ) {
		jsonPath = '/na/support/contact/contact.json';
		areas = [
			{ text: "ALL", value: "" },
			{ text: "Argentina", value: "1" },
			{ text: "Australia", value: "2" },
			{ text: "Bolivia", value: "3" },
			{ text: "Brazil", value: "4" },
			{ text: "Canada", value: "5" },
			{ text: "Carribean & British West Indies", value: "6" },
			{ text: "Chile", value: "7" },
			{ text: "Colombia", value: "8" },
			{ text: "Costa Rica", value: "9" },
			{ text: "Dominican Republic", value: "10" },
			{ text: "Ecuador", value: "11" },
			{ text: "El Salvador", value: "12" },
			{ text: "French Polynesia", value: "13" },
			{ text: "Guatemala", value: "14" },
			{ text: "Honduras", value: "15" },
			{ text: "Mexico", value: "16" },
			{ text: "New Zealand", value: "17" },
			{ text: "Nicaragua", value: "18" },
			{ text: "Panama", value: "19" },
			{ text: "Peru", value: "20" },
			{ text: "Venezuela", value: "21" },
			{ text: "Uruguay", value: "22" },
			{ text: "Fiji", value: "23" },
			{ text: "Papua New Guinea", value: "24" }
		];
	}

	let jqXHR = $.getJSON(jsonPath);

	jqXHR.done(function(json){
		new Vue({
			el: "#dealersApp",
			data: {
				items: json,
				areas: areas,
				selectId: selectids()
			},
			computed: {
				eventedAction: function () {
					let list = this.items.slice();

					// Idでフィルタリング実施
					if(this.selectId) {
						list = list.filter(element => {
							return element.Id === this.selectId;
						});
					}
					return list;
				}
			}
		});
		function selectids() {
			let paraId = "";
			return paraId;
		}
	});
});
